import { render } from "./BonusHistory.vue?vue&type=template&id=c7e22afc&scoped=true"
import script from "./BonusHistory.vue?vue&type=script&lang=js"
export * from "./BonusHistory.vue?vue&type=script&lang=js"

import "./BonusHistory.vue?vue&type=style&index=0&id=c7e22afc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c7e22afc"]])

export default __exports__